import React from 'react';
import { motion } from 'framer-motion';
import { LineChart, Zap, TreePine } from 'lucide-react';
import { Link } from 'react-router-dom';

const services = [
  {
    icon: LineChart,
    title: 'Climate Finance and Economics',
    description: 'Comprehensive analysis and implementation of climate-focused economic strategies.',
    features: [
      'Climate risk assessment',
      'Carbon pricing mechanisms',
      'Climate adaptation financing',
      'Economic policy analysis'
    ],
    link: '/capabilities/climate-finance'
  },
  {
    icon: Zap,
    title: 'Energy Finance',
    description: 'Supporting Africa\'s transition to sustainable energy through innovative financing.',
    features: [
      'Renewable energy project financing',
      'Energy efficiency programs',
      'Clean energy investment strategies',
      'Energy transition planning'
    ],
    link: '/capabilities/energy-finance'
  },
  {
    icon: TreePine,
    title: 'Nature and Biodiversity Finance',
    description: 'Financial solutions for preserving and enhancing natural ecosystems.',
    features: [
      'Biodiversity offset mechanisms',
      'Conservation finance',
      'Natural capital investment',
      'Ecosystem services valuation'
    ],
    link: '/capabilities/biodiversity-finance'
  }
];

export default function ServicesList() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <motion.div
                key={service.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-all"
              >
                <Link to={service.link} className="block">
                  <div className="flex items-center space-x-4 mb-6">
                    <div className="bg-green-100 p-3 rounded-full">
                      <Icon className="h-6 w-6 text-green-600" />
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900">
                      {service.title}
                    </h3>
                  </div>
                  <p className="text-gray-600 mb-6">{service.description}</p>
                  <ul className="space-y-3">
                    {service.features.map((feature) => (
                      <li key={feature} className="flex items-center text-gray-700">
                        <span className="w-1.5 h-1.5 bg-green-500 rounded-full mr-2" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}